import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './store/store';
import { App } from './pages/app/app.component';
import { ErrorBoundary } from './components/error-boundary/error-boundary.component';
import './style.css';

const root = createRoot(document.getElementById('root')!);

root.render(
  <Provider store={store}>
    <ErrorBoundary>
      <StrictMode>
        <App/>
      </StrictMode>
    </ErrorBoundary>
  </Provider>
);
